export default function identity(i) {
  return i
}
